import { useCallback } from 'react'

import { type ObservabilityTool } from 'components/status-checks/authentication-form-utils'
import { isObservabilityToolOfType } from 'components/status-checks/authentication-form-validation-utils'
import { DynatraceEntitySelectionSource } from 'components/status-checks/form/status-check/dynatrace/DynatraceMonitorSelection'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export enum StatusCheckCategoryFieldVisibilityState {
  OPTIONAL = 'optional',
  REQUIRED = 'required'
}

/**
 * Returns a getter function which returns as flag indicating whether the 'category' field
 * should be displayed within the Status Check form.
 */
export function useGetCategoryFieldVisibilityState() {
  return useCallback(
    (
      observabilityTool: ObservabilityTool,
      dynatraceSelectorType?: DynatraceEntitySelectionSource
    ) => {
      const isDynatraceObservabilityTool = isObservabilityToolOfType(
        ObservabilityToolType.DYNATRACE,
        observabilityTool
      )

      /*
       * Dynatrace Selector types that are not the 'Problems URL' both require the
       * category field to be present. Otherwise we fall-back to optionally displaying the
       * field if the RI feature flag is present
       */
      const isRequired =
        isDynatraceObservabilityTool &&
        dynatraceSelectorType !== DynatraceEntitySelectionSource.PROBLEMS_URL

      switch (true) {
        case isRequired:
          return StatusCheckCategoryFieldVisibilityState.REQUIRED
        default:
          return StatusCheckCategoryFieldVisibilityState.OPTIONAL
      }
    },
    []
  )
}
